module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="header-wrap" data-toggle="expand-spoiler"><header><h5 class="module-title">'+
((__t=( i18n.tc( "ControlMap", "Finder" )))==null?'':__t)+
'</h5><i class="icon icon-material icon-expand"></i></header></a><div id="finder-vue"><p v-show="model.modelError" class="error">ERROR! {{ model.modelError }}</p><defa-radio-strip v-model="sliderValue" :options="sliderOptions" v-bind:class="{ errorState: model.finderActivated === null}" v-on:input="save(sliderValue, \'finderActivated\')"></defa-radio-strip><p v-show="model.finderActivatedError" class="error">{{ model.finderActivatedError }}</p><p v-show="model.gpsFixError" class="error">{{ model.gpsFixError }}</p></div><div class="expand-spoiler';
 if ( isOpen ) { 
__p+=' open';
 } 
__p+='" data-container="expand-spoiler"><div class="expand-content"><div class="map-wrapper block" data-container="finderMap-container"></div><fieldset class="button-wrap"><button class="primary hidden" data-click="finderMap-refresh">'+
((__t=( i18n.tc( "UnitMap", "Refresh" ) ))==null?'':__t)+
'</button></fieldset></div></div>';
}
return __p;
};
